<template>
    <v-row>
        <v-col cols="12" sm="12">
            
            <v-row v-if="usuario.tipo.toUpperCase() == 'ADMIN'">
                <v-col cols="12" sm="12">
                    <h2>Alterar senha</h2>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <v-text-field
                        label="Nova Senha"
                        v-model="senha"
                        type="password"
                        outlined
                    ></v-text-field>
                    <v-text-field
                        label="Repetir Nova Senha"
                        v-model="repetirSenha"
                        type="password"
                        outlined
                    ></v-text-field>
                    <v-btn color="info" @click="alterarSenha"><v-icon>check</v-icon>&nbsp; Alterar</v-btn>
                </v-col>
            </v-row>
    
            <v-row v-if="usuario.tipo.toUpperCase() == 'ADMIN'">
                <v-col cols="12" md="12">
                    <br><hr><br>
                </v-col>
            </v-row>
    
            <v-row v-if="usuario.tipo.toUpperCase() == 'CORRETOR'">
                <v-col cols="12" sm="12">
                    <h2>Corretor, <br>Caso você deseje receber de forma automática, via What'sApp, informações da Previsul, preencha os campos e selecione abaixo:</h2>
                </v-col>
                <v-col cols="12" sm="12" md="4">
    
                    <v-text-field
                        label="Nome Contato"
                        v-model="dadosServicoNotificacoes.nomeContato"
                        type="text"
                        outlined
                         :rules="dadosServicoNotificacoes.receberEmissaoApolice == true ? [rules.required, rules.minimoNome] : []"                    
                    ></v-text-field>
    
                    <v-text-field
                        label="Nome Social"
                        v-model="dadosServicoNotificacoes.nomeSocial"
                        type="text" 
                        outlined                
                    ></v-text-field>
    
                    <v-text-field
                        label="Celular"
                        v-model="dadosServicoNotificacoes.telefoneContato"
                        type="text"
                        outlined
                        :rules="dadosServicoNotificacoes.receberEmissaoApolice == true ? [rules.required, rules.minimoCelular] : []"
                        v-mask="'###########'"
                    ></v-text-field>
    
                    <v-switch
                    v-model="dadosServicoNotificacoes.receberEmissaoApolice"
                    label="Emissões de Apólice"
                    ></v-switch>
    
    
                    <v-btn color="info" @click="atualizarNotificacao"><v-icon>check</v-icon>&nbsp; Atualizar</v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
    </template>
    
    <script>
    
        import Vue from 'vue';
        import { mapState, mapGetters } from 'vuex';
        import Helpers from "@/utilities/Helpers";
    
        export default {
            mixins: [Helpers],
            data() {
                return {
                    senha: "",
                    repetirSenha: "",
                    dadosServicoNotificacoes:{
                        desejoReceberNotificacao: false,
                    
                        guid: null,
                        nomeContato: "",
                        nomeSocial: "",
                        telefoneContato: "",
                        codigoCorretor: null,
                        personId: null,
                        receberEmissaoApolice: false
                    },
                    rules: {
                        required: value => !!value || 'Obrigatório',
                        minimoNome: value => value != undefined && value.length >= 4 || 'Nome deve ter no mínimo 4 caracteres',
                        minimoCelular: value => value != undefined && value.length >= 10 || 'Celular invalido, (digitar o ddd + número)',
                    },
                }
            },   
            methods: {
                alterarSenha(){
                    if(this.senha != this.repetirSenha){
                        this.showToast("warning","Atenção!","As senhas não conferem.");
                        return;
                    }
                    
                    let url = "Login/alterar-senha";
                    let data = {
                        Usuario: this.usuario.email,
                        Senha: this.senha
                    }
                    Vue.prototype.$httpPortal.post(url, data)
                    .then(res => {
                        console.log(res.data);
                        if(res.data == true)
                        {
                            this.showToast("success","Sucesso!","Senha alterada com sucesso.");
                            console.log(this.senha);
                        }
                        else
                        {   
                            this.showToast("error","Erro!","Há problemas detectados");
                        }
                        this.fullLoading = false; 
                    })
                    .catch(error => {
                        this.showToast("error","Erro!","Há problemas detectados");
                    });
    
    
                },
                buscarEnvioMensagem(){            
                    let tipoUsuario =  this.usuario.tipo === 'CORRETOR' ? 1 : 2;
                    let url = "EnvioMensagem/pessoa/" + this.usuario.codCorretor + "/" + this.usuario.personId + "/" + tipoUsuario;
                    Vue.prototype.$httpPortal.get(url)
                    .then(res => {
                        //console.log(res.data);
    
                        this.dadosServicoNotificacoes.guid = res.data.guid;
                        this.dadosServicoNotificacoes.codigoCorretor = res.data.codigoCorretor;
                        this.dadosServicoNotificacoes.personId = res.data.personId;
                        this.dadosServicoNotificacoes.nomeContato = res.data.nomeContato;
                        this.dadosServicoNotificacoes.nomeSocial = res.data.nomeSocial;
                        this.dadosServicoNotificacoes.telefoneContato = res.data.telefoneContato;
                        this.dadosServicoNotificacoes.tipoUsuario = res.data.tipoUsuario;
                        this.dadosServicoNotificacoes.receberEmissaoApolice = res.data.receberEmissaoApolice;
                    })
                    .catch(error => {
                        this.showToast("error","Erro!","Há problemas detectados");
                    });
                },
                atualizarNotificacao(){
                    if(this.dadosServicoNotificacoes.receberEmissaoApolice == true && (this.dadosServicoNotificacoes.nomeContato.length < 4 || this.dadosServicoNotificacoes.telefoneContato.length < 10)){
                        this.showToast("warning","Inválido!","Informações para notificação estão inválidas");
                        return;
                    }    
    
                    let url = "EnvioMensagem";
                    let data = {
                        DesejoReceberNotificacao: this.dadosServicoNotificacoes.desejoReceberNotificacao,
                        Guid: this.dadosServicoNotificacoes.guid,
                        PersonId: this.usuario.personId,
                        CodigoCorretor: this.usuario.codCorretor,
                        ApplicationId: 1,
                        LoginId: 0,
                        TipoUsuario: this.usuario.tipo === 'CORRETOR' ? 1 : 2,
                        TipoNotificacao: 1,
                        NomeContato: this.dadosServicoNotificacoes.nomeContato,
                        nomeSocial: this.dadosServicoNotificacoes.nomeSocial,
                        EmailContato: this.usuario.email,
                        telefoneContato: this.dadosServicoNotificacoes.telefoneContato,
                        ReceberEmissaoApolice: this.dadosServicoNotificacoes.receberEmissaoApolice
                    }
                    Vue.prototype.$httpPortal.put(url, data)
                    .then(res => {
                        this.showToast("success","Sucesso!","Notificação atualizada com sucesso.");
                        console.log(res.data);
                    })
                    .catch(error => {
                        this.showToast("error","Erro!","Há problemas detectados");
                    });
                }
            },
            computed: {
            ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
            },
            mounted(){
                this.buscarEnvioMensagem();
                console.log("Configuracao > this.usuario");
                console.log(this.usuario);
            }
        }
    </script>
    